import { FinanceFundListStatus } from "@/features/finance/model/finance-types";
import type { TableQueryConfig } from "@/shared/lib/data-table/table-query";

/**
 * Declarative table config for the Finance → Funds list. The backend supports search + status,
 * page/limit pagination and sorting on createdAt | updatedAt | name
 * (apps/api/src/modules/finance/schemas/funds.schemas.ts).
 */
export const fundsTableQueryConfig: TableQueryConfig = {
  id: "finance-funds",
  titleKey: "toolbar.filters",
  buttonLabelKey: "toolbar.filters",
  cancelLabelKey: "toolbar.cancel",
  resetLabelKey: "toolbar.reset",
  applyLabelKey: "toolbar.applyFilters",
  clearLabelKey: "toolbar.clearFilters",
  search: {
    placeholderKey: "searchPlaceholder",
    debounceMs: 300,
    className: "w-full max-w-sm",
  },
  defaultSortBy: "name",
  defaultSortOrder: "asc",
  defaultLimit: 20,
  defaultPage: 1,
  filters: [
    {
      id: "status",
      type: "select",
      key: "status",
      labelKey: "toolbar.status",
      options: {
        type: "static",
        items: [
          { value: "", labelKey: "toolbar.allStatuses" },
          { value: FinanceFundListStatus.Active, labelKey: `toolbar.statuses.${FinanceFundListStatus.Active}` },
          { value: FinanceFundListStatus.Closed, labelKey: `toolbar.statuses.${FinanceFundListStatus.Closed}` },
          { value: FinanceFundListStatus.Archived, labelKey: `toolbar.statuses.${FinanceFundListStatus.Archived}` },
        ],
      },
    },
  ],
};
